export default "__VITE_ASSET__9e12d987__"